// extracted by mini-css-extract-plugin
module.exports = {"light":"AccordionBlock_light__MVj4L","dark":"AccordionBlock_dark__d2kYf","wrapper":"AccordionBlock_wrapper__trMKH","container":"AccordionBlock_container__5VLjM"};